import { dew as _FindAndReplaceRecordRequestDeprecatedDew } from "./FindAndReplaceRecordRequestDeprecated";
import { dew as _FindAndReplaceRecordRequestDew } from "./FindAndReplaceRecordRequest";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FindAndReplaceRecordRequest = exports.FindAndReplaceRecordRequestDeprecated = void 0;
  var FindAndReplaceRecordRequestDeprecated_1 = _FindAndReplaceRecordRequestDeprecatedDew();
  Object.defineProperty(exports, "FindAndReplaceRecordRequestDeprecated", {
    enumerable: true,
    get: function () {
      return FindAndReplaceRecordRequestDeprecated_1.FindAndReplaceRecordRequestDeprecated;
    }
  });
  var FindAndReplaceRecordRequest_1 = _FindAndReplaceRecordRequestDew();
  Object.defineProperty(exports, "FindAndReplaceRecordRequest", {
    enumerable: true,
    get: function () {
      return FindAndReplaceRecordRequest_1.FindAndReplaceRecordRequest;
    }
  });
  return exports;
}